import React, {useEffect} from 'react'
import {OrderHeader} from '../../../componentsv1'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {ViewOrder} from '../../../models/OrderState'
import {useParams} from 'react-router-dom'
import {formatToDateString4} from 'app/format/date'
import capitalize from 'lodash/capitalize'
import lowerCase from 'lodash/lowerCase'
import Prompt from '_core/components/Prompt'
import {
  createRefundOrder,
  resetOrderRefundState,
  selectIsDirty,
  selectViewOrder,
  selectIsFetching,
} from 'app/features/orders/redux/order/refundSlice'
import Loader from '../../../componentsv1/shared/Loader'
import RefundActionWrapper from './actions/RefundActionWrapper'
import ReloadAlert from '_core/components/RefreshPrombt'

interface Props {
  children: React.ReactNode
}

export const RefundPageWrapper: React.FC<Props> = ({children}) => {
  const {orderId, fulfillmentId}: any = useParams<any>()
  const dispatch = useDispatch()
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)
  const isFetching = useSelector<RootState, boolean>(selectIsFetching)
  const isDirty = useSelector<RootState, boolean>(selectIsDirty)

  useEffect(() => {
    if (orderId && fulfillmentId) {
      dispatch(createRefundOrder({orderId, fulfillmentId}))
    }
  }, [orderId, dispatch, fulfillmentId])

  useEffect(
    () => () => {
      dispatch(resetOrderRefundState())
    },
    [dispatch]
  )

  if (isFetching) {
    return <Loader />
  }

  return (
    <>
      <Prompt when={isDirty} onOK={() => true} onCancel={() => false} />
      <OrderHeader
        title={`#${order?.orderNumber} Refund`}
        routePath={`/orders/${orderId}/fulfillments/view`}
        fulfillmentStatus={order.fulfillmentStatus}
        paymentStatus={order.financialStatus}
        subTitle={
          <div className='text-muted fs-7 fw-bold pt-2'>
            {formatToDateString4(order.createdAt)} Placed order via{' '}
            {capitalize(lowerCase(order.orderType).trim())}
          </div>
        }
      >
        <ReloadAlert>
          <RefundActionWrapper />
        </ReloadAlert>
      </OrderHeader>
      {children}
    </>
  )
}

export default RefundPageWrapper
